/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import RefundRequestTable from "../../../Tables/RefundRequestTable";
import Search from "../../../Common/Search";
import Sorting from "../../../Common/Sorting";
import { refundRequestList } from "../../../../stores/actions/refund-request.actions.types";
import { connect } from "react-redux";
import { sortingCodeList } from "../../../../utilities/enums/sorting";
import { BiLoaderAlt } from "react-icons/bi";
import Paginations from "../../../Common/Pagination";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";

const refundStatusValues = [
  { label: "All", value: "" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
];

const RefundRequestList = ({ refundRequestList, loading }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [refundRequests, setRefundRequests] = useState([]);
  const [sorting, setSorting] = useState([
    {
      whom: "createdAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    getRefundRequestList(search, pagination.page, sorting, status);
  }, [search, sorting, pagination.page, status]);

  const getRefundRequestList = (
    q = search,
    page = pagination.page,
    sort = sorting,
    status,
  ) => {
    const callback = (res) => {
      if (res.success) {
        setRefundRequests(res?.data?.data || []);
      }
    };

    let request = { callback, data: { q, page, sort, status } };
    refundRequestList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  const handleChangeStatus = (value) => {
    setStatus(value);
  };

  return (
    <div>
      <MetaHead title='Refund Requests' />
      <div className='flex flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          placeholder='Search by order ID'
          search={search}
          setSearch={setSearch}
        />
        <Sorting
          name={"Status"}
          values={refundStatusValues}
          onChange={handleChangeStatus}
        />
        <Sorting
          name={"Sort"}
          values={sortingCodeList}
          onChange={handleChangeSorting}
        />
      </div>

      {loading ? (
        <div className='flex rounded dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : refundRequests?.length ? (
        <>
          <RefundRequestTable
            refundRequests={refundRequests}
            getRefundRequestList={getRefundRequestList}
          />
        </>
      ) : (
        <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          Not found
        </div>
      )}
      <Paginations pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});
export default connect(mapStateToProps, {
  refundRequestList,
})(RefundRequestList);
